import { GoSettings } from "react-icons/go";
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect } from "react";

import { fetchProducts } from "../../features/products/products-slice";
import Divider from "../../components/Divider";
import ProductCard from "../../components/ProductCard";
import Select from "../../components/Select";
import Pagination from "../../components/Pagination";
import ShopFilters from "./ShopFilters";
import Modal from "../../components/Modal";

const options = [
  {
    id: 0,
    value: "relevancy",
    text: "Relevancy",
  },
  {
    id: 1,
    value: "top-reviews",
    text: "Top Reviews",
  },
  {
    id: 2,
    value: "highest-price",
    text: "Highest Price",
  },
  {
    id: 3,
    value: "lowest-price",
    text: "Lowest Price",
  },
  {
    id: 4,
    value: "most-recent",
    text: "Most Recent",
  },
];

const ShopItems = () => {
  return (
    <div className="">
      <div className="shop-items-wrapper px-4">
        <div className="header">
          <div className="sort justify-end xs:hidden lg:flex">
            <div className="flex items-center">
              <div className="pr-2">
                <span>Sort:</span>
              </div>
              <div className="">
                <Select options={options} />
              </div>
            </div>
          </div>
          <div className="flex justify-between items-center p-3">
            <div className="title text-xl">
              <h2>Items</h2>
            </div>
            <div className="filters text-[15px]">
              <Modal
                maxWidth="xs:max-w-full md:max-w-md"
                title={"Login"}
                modalButton={
                  <div className="flex items-center py-2 px-5 cursor-pointer">
                    <span className="px-1">
                      <GoSettings />
                    </span>
                    <span className="px-1">Filters</span>
                  </div>
                }
              >
                <ShopFilters />
              </Modal>
            </div>
          </div>
          <Divider />
        </div>
        <div className="products p-4">
          <div className="products-wrapper flex flex-wrap">
            {Array(8)
              .fill(true)
              .map((card, index) => {
                return <ProductCard key={index} />;
              })}
          </div>
        </div>
      </div>
      <div className="pagination py-3 mb-12">
        <Pagination />
      </div>
    </div>
  );
};

export default ShopItems;
